import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * The "back to the product" CTA that every article closes on. Copy is
 * intentionally the exact line the product brief requested — the whole
 * point of the Buying Advice section is to funnel curious readers into
 * the recommendation tool.
 */
export const ArticleCta = ({ prefill = "" }) => {
  const navigate = useNavigate();
  const go = () => {
    if (prefill) navigate(`/chat?q=${encodeURIComponent(prefill)}`);
    else navigate("/chat");
  };
  return (
    <aside
      data-testid="article-cta"
      className="my-16 rounded-2xl p-8 sm:p-10 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent border border-primary/20"
    >
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-primary/15 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl sm:text-2xl font-serif mb-2">
            Still unsure what to buy?
          </h3>
          <p className="text-muted-foreground mb-5 text-sm sm:text-base">
            Ask Should I Buy It and get an AI-powered recommendation in
            seconds — with pros, cons, price and a direct Amazon link.
          </p>
          <button
            onClick={go}
            data-testid="article-cta-button"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-primary text-primary-foreground font-medium hover:opacity-90 transition"
          >
            Ask Should I Buy It
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </aside>
  );
};
